import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";

import authReducer from "./authReducer";
import todosReducer from "./todosReducer";
import betsReducer from "./betsReducer";

export default combineReducers({
  auth: authReducer,
  todos: todosReducer,
  firebase: firebaseReducer,
  bets: betsReducer,
  firestore: firestoreReducer
});
